// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueClipboard from 'vue-clipboard2'
import VueQuillEditor from 'vue-quill-editor'
import store from './story/'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import * as getData from './service/getData.js'
Vue.use(ElementUI)
Vue.use(VueQuillEditor)
Vue.use(VueClipboard)

import components from './components/'
import '../static/ueditor/ueditor.config.js'
import '../static/ueditor/ueditor.all.min.js'
import '../static/ueditor/lang/zh-cn/zh-cn.js'
import '../static/ueditor/ueditor.parse.min.js'
Object.keys(components).forEach((key) => {
  var name = key.replace(/(\w)/, (v) => v.toUpperCase()) // 首字母大写
  Vue.component(`v${name}`, components[key])
})
import Pagination from './components/Pagination'
// import IconSvg from './components/SvgIcon'
Vue.component(`Pagination`, Pagination)


Vue.prototype.$checkPermissions = (val) => {
  return JSON.parse(sessionStorage['myPermission']).indexOf(val)>-1
}
Vue.prototype.$permissionsCheck = (val) => {
  let temp = JSON.parse(sessionStorage['myPermission'])

  console.log(val,temp[val],1231)
  return temp[val]
}


router.beforeEach((to, from, next) => {
  next()
  // //NProgress.start();
  // if (to.path == '/login') {
  //   sessionStorage.clear();
  //   console.log("login",to.path)
  //   next()
  // }else{
  //   console.log("check")
  //   //检查登录状态
  //   getData.checkLogin().then(res => {
  //     if(res.data.rCode == 'success'){
  //       next()
  //     }else {
  //       next({path: '/login'})
  //     }
  //   })
  // }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  template: '<App/>',
  components: { App },

})



// WEBPACK FOOTER //
// ./src/main.js